export const LogoMark = ({ size = 40, className = "" }) => (
  <svg
    viewBox="0 0 64 64"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label="Aarogyam Bharat logo"
  >
    <circle cx="32" cy="32" r="30" fill="#132A13" />
    <path d="M32 50c0-14 6-24 18-30 0 14-6 26-18 30z" fill="#90A955" />
    <path d="M32 50c-1-10-6-17-14-21 1 10 5 18 14 21z" fill="#4F772D" />
    <path d="M32 50V34" stroke="#C6A052" strokeWidth="2.4" strokeLinecap="round" />
    <circle cx="44" cy="18" r="4" fill="#C6A052" />
  </svg>
);

export const LogoFull = ({ dark = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark size={42} />
    <div className="leading-tight">
      <p className={`font-serif text-xl font-semibold tracking-wide ${dark ? "text-ivory" : "text-forest"}`}>
        AAROGYAM BHARAT
      </p>
      <p className={`text-[10px] uppercase tracking-[0.25em] ${dark ? "text-moss" : "text-gold"}`}>
        Holistic Health Coaching
      </p>
    </div>
  </div>
);
